import { UrlMatchResult, UrlSegment } from '@angular/router';

const SUPPORTED_LANGS = new Set(['en', 'ar', 'ku']);

function isNumericAdId(segment: UrlSegment | undefined): boolean {
	return !!segment && /^\d+$/.test(segment.path);
}

export function detailRouteMatcher(segments: UrlSegment[]): UrlMatchResult | null {
	if (segments.length < 3 || segments[0]?.path !== 'detail') {
		return null;
	}

	const id = segments[segments.length - 1];
	if (!isNumericAdId(id)) {
		return null;
	}

	return {
		consumed: segments,
		posParams: {
			id,
		},
	};
}

export function localizedDetailRouteMatcher(segments: UrlSegment[]): UrlMatchResult | null {
	if (segments.length < 4 || !SUPPORTED_LANGS.has(segments[0]?.path) || segments[1]?.path !== 'detail') {
		return null;
	}

	const id = segments[segments.length - 1];
	if (!isNumericAdId(id)) {
		return null;
	}

	return {
		consumed: segments,
		posParams: {
			lang: segments[0],
			id,
		},
	};
}
